import { render, staticRenderFns } from "./FormRegion.vue?vue&type=template&id=ab2e5b96&scoped=true&"
import script from "./FormRegion.vue?vue&type=script&lang=js&"
export * from "./FormRegion.vue?vue&type=script&lang=js&"
import style0 from "./FormRegion.vue?vue&type=style&index=0&id=ab2e5b96&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2e5b96",
  null
  
)

export default component.exports